import { Maybe } from '@neo.tax/shared/graphql';

export const formatCompanyName = (companyName: Maybe<string>): string => {
  if (!companyName) {
    return '';
  }
  return companyName[companyName.length - 1].toLowerCase() === 's' ? `${companyName}'` : `${companyName}'s`;
};

export const pascalToSnakeCase = (input: string): string =>
  input
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();

export const formatContributorName = (contributorName: string | null | undefined): string => {
  if (!contributorName) {
    return 'No Name';
  }
  return contributorName.trim();
};

export const formatContributorNameWithEmail = (
  contributorName: string | null | undefined,
  email: string | null | undefined,
): string => {
  const trimmedName = contributorName?.trim();
  const trimmedEmail = email?.trim();
  if (trimmedName && trimmedEmail) {
    return `${trimmedName} (${trimmedEmail})`;
  }
  return trimmedName || trimmedEmail || formatContributorName(contributorName);
};
